import UserInfoModal from "./User/Info/Info.vue";
import ApplicantInfoModal from "./User/Applicant/Applicant.vue";
import ShiftEditModal from "./Shift/Edit/Edit.vue";
import VideoPreviewModal from "./Video/Preview/Preview.vue";
// import CovidCertModal from "./CovidCertModal/CovidCertModal.vue";
import CertPreviewModal from "./CovidCertModal/CertificatePreviewModal.vue";
import PreviewModal from "./DocumentModal/PreviewModal.vue";
import ContractPreviewModal from "./ContractModal/ContractPreviewModal.vue";
import GuestPreviewModal from "./GuestShiftModal/GuestPreviewModal.vue";
import ApplicationsModal from "./ApplicationsModal/ApplicationsPreviewModal.vue";
import BlockApplicationsModal from "./ApplicationsModal/BlockApplicationsPreviewModal.vue";
import AgencyInfoModal from "./User/Agency/Agency.vue"
import FileApplicationPreviewModal from "./ApplicationsModal/FileApplicationPreviewModal.vue";
import SepratePreviewModal from "./User/Applicant/SepratePreviewModal.vue";
import PharmacyInfoModal from "./User/JobListing/PharmacyPreviewModal.vue";
import JobApplicantInfoModal from "./User/JobListing/ApplicantPreviewModal.vue";

import BlockShiftModal from "./BlockShiftModal/BlockShiftModal.vue";
export default {
  
  install(app, mitt) {
    app.config.globalProperties.$modals = {
     
      open(name = null, params = {}) {
        let options = {
          show: true,
          params: params,
        };
        mitt.emit(name, options);
      },
      close(name = null, params = {}) {
        let options = {
          show: false,
          params: params,
        };
        mitt.emit(name, options);
      },
    };
    app.provide("$modals", app.config.globalProperties.$modals);
  },
};

export {
  UserInfoModal,
  ShiftEditModal,
  VideoPreviewModal,
  CertPreviewModal,
  PreviewModal,
  ContractPreviewModal,
  GuestPreviewModal,
  ApplicationsModal,
  ApplicantInfoModal,
  AgencyInfoModal,
  BlockApplicationsModal,
  FileApplicationPreviewModal,
  SepratePreviewModal,
  PharmacyInfoModal,
  JobApplicantInfoModal,
  BlockShiftModal
};
